/** Parse une date ISO en ignorant le timezone offset — retourne un Date avec les composants date/heure locaux */
export function parseIsoLocal(iso) {
    const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!match)
        return null;
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), Number(match[4]), Number(match[5]));
}
